// FormContent.js
import React from 'react';
import StaffInformationForm from '../../FormSections/StaffInformation/StaffInformationForm';
import IdentificationDocumentForm from '../../FormSections/IdentificationDoc/IdentificationDocuments';
import EmploymentForm from '../../FormSections/Employment/Employment';
import ContactForm from '../../FormSections/Contact/Contact';
import EquipmentForm from '../../FormSections/Equipment/EquipmentForm';
import TrainingForm from '../../FormSections/Training/TrainingForm';
import MedicalForm from '../../FormSections/Medical/MedicalForm';

/**
 * FormContent component that bridges between old and new validation approaches
 */
const FormContent = ({
                         activeTab,
                         formData,
                         onSave,
                         sectionProgress
                     }) => {

    // Create validation handlers for each section
    // In FormContent.js
    // const createValidationHandler = (section) => {
    //     return function handleValidation(valueOrPercent) {
    //         console.log(`Validation handler for ${section} called with:`, valueOrPercent);
    //
    //         // Handle array data from equipment form
    //         if (section === 'equipment' && Array.isArray(valueOrPercent)) {
    //             console.log(`Received equipment array with ${valueOrPercent.length} item(s)`);
    //
    //             // Force update the form data in the parent component
    //             onSave(section, valueOrPercent);
    //
    //             // Log that progress update was triggered
    //             console.log(`Forced progress update for ${section} with array data`);
    //             return;
    //         }
    //
    //         // Handle percentage values
    //         if (typeof valueOrPercent === 'number') {
    //             console.log(`Received percentage update for ${section}: ${valueOrPercent}%`);
    //
    //             // Force progress update with current data
    //             if (formData[section]) {
    //                 onSave(section, formData[section]);
    //                 console.log(`Forced progress update for ${section} with percentage data`);
    //             }
    //         }
    //         // Handle boolean values (legacy approach)
    //         else if (valueOrPercent === true && formData[section]) {
    //             console.log(`Received boolean validation for ${section}`);
    //             onSave(section, formData[section]);
    //         }
    //     };
    // };

    // Create validation handlers for each section
    const createValidationHandler = (section) => {
        return function handleValidation(valueOrPercent) {
            console.log(`Validation handler for ${section} called with:`, valueOrPercent);

            // Handle array data for components that return arrays (equipment, medical, training)
            if ((section === 'equipment' || section === 'medical' || section === 'training') && Array.isArray(valueOrPercent)) {
                console.log(`Received ${section} array with ${valueOrPercent.length} item(s)`);

                // Force update the form data in the parent component
                onSave(section, valueOrPercent);

                // Log that progress update was triggered
                console.log(`Forced progress update for ${section} with array data`);
                return;
            }

            // Handle percentage values
            if (typeof valueOrPercent === 'number') {
                // This is a percentage update (e.g. from identification_doc or staff_info)
                console.log(`Received percentage update for ${section}: ${valueOrPercent}%`);

                // For percentage updates, trigger a progress recalculation
                // by calling onSave with the current data
                if (formData[section]) {
                    console.log(`Forcing progress update for ${section} based on percentage`);
                    onSave(section, formData[section]);
                }
            }
            // Handle boolean values (legacy approach)
            else if (valueOrPercent === true && formData[section]) {
                console.log(`Received boolean validation (true) for ${section}`);
                onSave(section, formData[section]);
            }
        };
    };

    // const createValidationHandler = (section) => {
    //     return function handleValidation(valueOrPercent) {
    //         console.log(`Validation handler for ${section} called with:`, valueOrPercent);
    //
    //         // Handle both boolean and percentage cases
    //         if (typeof valueOrPercent === 'number') {
    //             // This is a percentage from the IdentificationDocuments component
    //             console.log(`Received percentage update for ${section}: ${valueOrPercent}%`);
    //             // We don't call onSave here because the component will directly update
    //             // the form data through its own save mechanism
    //
    //             // The percentage will be ignored because progress is calculated internally
    //             // by the useFormProgress hook based on required fields
    //         } else if (valueOrPercent === true && formData[section]) {
    //             // This is a boolean validation (legacy approach)
    //             onSave(section, formData[section]);
    //         }
    //     };
    // };
    // const createValidationHandler = (section) => {
    //     return function handleValidation(isValid) {
    //         if (isValid && formData[section]) {
    //             onSave(section, formData[section]);
    //         }
    //     };
    // };

    // Render the appropriate form section based on activeTab
    switch (activeTab) {
        case 'staff_info':
            return (
                    <StaffInformationForm
                        data={formData.staff_info}
                        onSave={(values) => onSave('staff_info', values)}
                        onValidationChange={createValidationHandler('staff_info')}
                        progress={sectionProgress.staff_info || 0}
                    />
            );
        case 'identification_doc':
            return (
                <IdentificationDocumentForm
                    data={formData.identification_doc || {}}
                    onSave={(values) => onSave('identification_doc', values)}
                    onValidationChange={createValidationHandler('identification_doc')}
                    progress={sectionProgress.identification_doc || 0}
                />
            );
        // case 'employment':
        //     return (
        //         <EmploymentForm
        //             data={formData.employment}
        //             onSave={(values) => onSave('employment', values)}
        //             onValidationChange={createValidationHandler('employment')}
        //             progress={sectionProgress.employment || 0}
        //         />
        //     );

        // In the employment case:
        case 'employment':
            console.log('Rendering EmploymentForm with data:', formData.employment);
            return (
                <EmploymentForm
                    data={formData.employment}
                    onSave={(values) => {
                        console.log('FormContent onSave called for employment with:', values);
                        onSave('employment', values);
                    }}
                    onValidationChange={(isValid) => {
                        console.log('FormContent validation called for employment with:', isValid);
                        createValidationHandler('employment')(isValid);
                    }}
                    progress={sectionProgress.employment || 0}
                />
            );
        case 'contact':
            return (
                <ContactForm
                    data={formData.contact}
                    onSave={(values) => onSave('contact', values)}
                    onValidationChange={createValidationHandler('contact')}
                    progress={sectionProgress.contact || 0}
                />
            );
        case 'equipment':
            return (
                <EquipmentForm
                    data={formData.equipment}
                    onSave={(values) => onSave('equipment', values)}
                    onValidationChange={createValidationHandler('equipment')}
                    progress={sectionProgress.equipment || 0}
                />
            );
        case 'training':
            return (
                <TrainingForm
                    data={formData.training}
                    onSave={(values) => onSave('training', values)}
                    onValidationChange={createValidationHandler('training')}
                    progress={sectionProgress.training || 0}
                />
            );
        case 'medical':
            return (
                <MedicalForm
                    data={formData.medical}
                    onSave={(values) => onSave('medical', values)}
                    onValidationChange={createValidationHandler('medical')}
                    progress={sectionProgress.medical || 0}
                />
            );
        default:
            return null;
    }
};

export default FormContent;